import styled, { device, color } from '@styled'

export const SectionWrapper = styled.section`
  padding-block-start: 60px;
  padding-block-end: 50px;
  ${color}
`

export const StyledText = styled.div`
  margin-inline-start: 10px;
  margin-inline-end: 10px;
  margin-block-start: 20px;
  margin-block-end: 20px !important;
  font-size: 18px;
  b {
    font-weight: 700;
  }
  a {
    text-decoration: underline;
    &:hover {
      text-decoration: none;
    }
  }
  ${device.small} {
    margin-inline-start: 34px;
    margin-inline-end: 34px;
  }
`
